import { render, staticRenderFns } from "./RecepcionTarimaComponent.vue?vue&type=template&id=5c45e36e&"
import script from "./RecepcionTarimaComponent.vue?vue&type=script&lang=js&"
export * from "./RecepcionTarimaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports